<template>
  <div>
    <div class="form-group" v-if="prefijo == enumeraciones.etiquetasDeHTML.Select">      
      <select v-bind:id="idDelInput" v-model="idDelModelo" class="form-control" @change="cambiarDatos($event)">
        <option v-if="tipo.Id == enumeraciones.tiposDeSelect.Seleccione.Id" :value="tipo.Id">{{tipo.Nombre}} un partido judicial</option>
        <option v-else-if="tipo.Id == enumeraciones.tiposDeSelect.Todos.Id" :value="tipo.Id">{{enumeraciones.tiposDeSelect.Todos.Nombre}} los partidos judiciales</option>
        <option v-for="PartidoJudicial in PartidosJudiciales" :value="PartidoJudicial.PartidoJudicialId" :key="PartidoJudicial.PartidoJudicialId">{{PartidoJudicial.Nombre}}</option>
      </select>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import axios from 'axios'
  import comun from '@/../static/js/comun'
  import api from '@/../static/js/api'

  export default {
    data() {
      return {
        enumeraciones,
        comun,
        PartidosJudiciales: [],
        idDelModelo: null
      }
    },
    props: {
      prefijo: Number,
      tipo: {
        Id: Number,
        Nombre: String 
      },
      idDelInput: String,
      valorDefinido: Number,
      parametros: Object
    },
    mounted() {      
      if(this.valorDefinido == undefined || this.valorDefinido == null)
        this.idDelModelo = this.tipo.Id;
      else
        this.idDelModelo = this.valorDefinido;

      const parametros = {
        llave: this.idDelInput,
        valor: this.idDelModelo
      }
      this.$store.dispatch("A_PJ_Catalogo_Establecer009PartidoJudicial", parametros);
    },
    methods: {
      cargaCatalogoDePartidosJudiciales: function() {
        if(this.parametros == null || this.parametros == undefined)
          this.parametros = {}
        this.parametros.EsPrueba = this.enumeraciones.EsPrueba

        axios.post(api.conexion + api.PJ.catalogos.C009PartidosJudiciales, this.parametros)
          .then(respuesta => {            
            if (respuesta.data.SiHayError) {
              console.log(respuesta);
              comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
            } else {              
              this.PartidosJudiciales = respuesta.data.PartidosJudiciales;  
              if(this.tipo.Id == enumeraciones.tiposDeSelect.Ninguno.Id && this.PartidosJudiciales.length >= 1 && (!this.valorDefinido || this.valorDefinido <= 0))
              {
                this.idDelModelo = this.PartidosJudiciales[0].PartidoJudicialId;
                this.elegirPrimerElemento(this.PartidosJudiciales[0].PartidoJudicialId);
              }
            }
          })
          .catch(excepcion => {
            console.log(excepcion);
            comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
          })
      },
      cambiarDatos(evento) {
        this.idDelModelo = evento.target.value;
        const parametros = {
          llave: this.idDelInput,
          valor: evento.target.value
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer009PartidoJudicial", parametros);
        this.$emit("valorParaElPadre", evento);
        //evento.target[evento.target.selectedIndex].label esto sirve para obtener el label de valor actual
      },
      elegirPrimerElemento(id) {
        const parametros = {
          llave: this.idDelInput,
          valor: id
        }
        
        this.$store.dispatch("A_PJ_Catalogo_Establecer009PartidoJudicial", parametros);
        //{id: id, nombre: this.PartidosJudiciales[id].Nombre}  lo que regresa el emit debe camrbiarse por esto si se busca obtener también el nombre 
        this.$emit("valorParaElPadrePrimerElemento", id);
      }
    },
    created() {
      this.cargaCatalogoDePartidosJudiciales();
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/PJ/Catalogos/009PartidosJudiciales.vue